import {
  ReactionSelect,
  Props as ReactionSelectProps,
} from '@web/conversations/Reactions/ReactionSelect/ReactionSelect';
import BodyPortal from '@web/components/BodyPortal';

import { Position, Wrapper } from './reactionPositionedSelect.styles';

export type Props = ReactionSelectProps & {
  position?: Position;
};

export const ReactionPositionedSelect = ({
  handleSelect,
  position = { left: 0, top: 0 },
}: Props) => (
  <BodyPortal>
    <Wrapper
      {...position}
      onClick={(e) => {
        e.nativeEvent.stopImmediatePropagation();
      }}>
      <ReactionSelect handleSelect={handleSelect} />
    </Wrapper>
  </BodyPortal>
);
